export default screenshots => {
	const option5 = screenshots?.screenshot5DescriptionHeader && {
		index: 4,
		questionTitle: screenshots?.screenshot5DescriptionHeader,
		answerText: screenshots?.screenshot5DescriptionText,
		icon: screenshots?.headerIcon5,
		screenshot: screenshots?.screenshot5?.file.url,
	};

	const option4 = screenshots.screenshot4DescriptionHeader && {
		index: 3,
		questionTitle: screenshots.screenshot4DescriptionHeader,
		answerText: screenshots.screenshot4DescriptionText,
		icon: screenshots.headerIcon4,
		screenshot: screenshots.screenshot4.file.url,
	};

	const screenshotSet = [
		{
			index: 0,
			questionTitle: screenshots.screenshot1DescriptionHeader,
			answerText: screenshots.screenshot1DescriptionText,
			icon: screenshots.headerIcon1,
			screenshot: screenshots.screenshot1.file.url,
		},
		{
			index: 1,
			questionTitle: screenshots.screenshot2DescriptionHeader,
			answerText: screenshots.screenshot2DescriptionText,
			icon: screenshots.headerIcon2,
			screenshot: screenshots.screenshot2.file.url,
		},
		{
			index: 2,
			questionTitle: screenshots.screenshot3DescriptionHeader,
			answerText: screenshots.screenshot3DescriptionText,
			icon: screenshots.headerIcon3,
			screenshot: screenshots.screenshot3.file.url,
		},
		...(option4 ? [option4] : []),
		...(option5 ? [option5] : []),
	];

	return screenshotSet;
};
